'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchGetSitePresetQuery } from '@module/queries/preset/presetQueryHooks';
import { canUseAdultShowAdMode, isAdultShowAdModeToggleActive } from './adultShowAdMode';
export const useAdultShowAdModeEligibility = () => {
  const $ = _c(12);
  const loginInfoQuery = useGetLoginInfoQuery();
  const sitePresetQuery = useFetchGetSitePresetQuery();
  const isResolved = (loginInfoQuery.isFetched || loginInfoQuery.isError) && (sitePresetQuery.isFetched || sitePresetQuery.isError);
  const mode = loginInfoQuery.siteMode?.mode;
  const isAdult = loginInfoQuery.isAdult;
  const isLogin = loginInfoQuery.isLogin;
  const presetCode = sitePresetQuery.data?.preset?.code;
  let t0;
  if ($[0] !== isAdult || $[1] !== isLogin || $[2] !== mode || $[3] !== presetCode) {
    t0 = canUseAdultShowAdMode({
      isLogin,
      isAdult,
      mode,
      presetCode
    });
    $[0] = isAdult;
    $[1] = isLogin;
    $[2] = mode;
    $[3] = presetCode;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const adultToggleShow = t0;
  let t1;
  if ($[5] !== isAdult || $[6] !== mode) {
    t1 = isAdultShowAdModeToggleActive({
      isAdult,
      mode
    });
    $[5] = isAdult;
    $[6] = mode;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== adultToggleShow || $[9] !== isResolved || $[10] !== t1) {
    t2 = {
      isResolved,
      adultToggleShow,
      isToggleActive: t1
    };
    $[8] = adultToggleShow;
    $[9] = isResolved;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};